import React, { useEffect, useContext, useState } from "react"
import RightSideBar from "../section-right-side-bar"
import { applyComma, lineCapital } from "../../../shared/functions"
import { generateBI } from "../../../services/apiservice"
import { JourneyContext } from "../../context/journeyContext"
import { PageContext } from "../../context/pageContext"
import { SectionContext } from "../../context/sectionContext"
import { getValueFromLookup } from "../../services/helperFunctions"
import * as lookup from "../../../../static/lookup.json"
import DocListPDF from "../../../documents/List-of-acceptable-documents.pdf"
export default function YourPremiumQuotationGuaranteedFuture(props){
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [data, setData] = useState()

  const handlePrevious = () => {
    pageState.pageData.map((element, index) => {
      if (
        element.sectionId ===
        props.sections[props.currentSectionIndex - 1].sectionId // setting section context from page context
      ) {
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: element.sectionId,
            sectionData: element.sectionData,
          }
        })
      }
    })
    props.setCurrentSectionIndex(prev => prev -1)
  }

  const handleProceed = () => {
    props.setCurrentPageIndex(prev => prev +1)
    props.setCurrentSectionIndex(0)
  }

  useEffect(async () => {
    console.log("journeyState", journeyState);
    console.log(sectionState, "sectionState")
      let payload = {
        journeyId: journeyState.journeyId,
      }
      const biApiData = await generateBI(payload)
      if (biApiData.data?.BIJson) {
        let biJson = JSON.parse(biApiData.data?.BIJson)
          setData(biJson)
      }
  }, [])

  return (
    <>
      <style>
        {`
          .mg-ckyc-top.desktop-view-right-side {
            margin-top: 39px;
          }
          
        
          @media (max-width: 767px) {
            .form-group span#plan_option-error {
              top: 49px;
            }
            .form-group span#policy_term-error {
              top: 51px;
            }
            .form-group span#payment_term-error {
              top: 50px;
            }
            .form-group span#payment_frequency-error {
              top: 51px;
            }
            .or-jeevan p{
              top: -14px;
            }
          }
        
          button.select2-selection__clear {
            display: none;
          }
          .guranteedSumAssurdBox{
            padding: 0px 0px 15px 15px;
          }
        
          .form-group {
            position: relative;
          }
        
          .text-danger {
            color: #a94442;
            position: absolute;
            left: 0;
            bottom: -20px;
          }
        
          #swords {
            position: absolute;
            z-index: 2;
            right: 38px !important;
            top: 0px;
          }
        
          #sumAssured-error {
            position: absolute;
            bottom: -3px;
            z-index: 2;
          }
        
          button.select2-selection__clear {
            display: none;
          }
        
          .sumassuredselect select#nonfilterselect {
            -webkit-appearance: none;
            -moz-appearance: none;
            background-image: url("images/arrow-sm.png");
            background-repeat: no-repeat;
            background-position-x: 99%;
            background-position-y: 17px;
          }
        
          #words {
            position: absolute;
            right: 58px;
            top: 27px;
          }
        
          select::-ms-expand {
            display: none;
          }
        
          .sumassuredselect {
            position: relative;
            height: 45px;
            width: 100%;
          }
        
          .sumassuredselect input.form-control {
            position: absolute;
            z-index: 2;
            width: calc(100% - 35px);
            left: 3px;
            height: 42px;
            top: 0;
            box-shadow: none;
            border: 0;
            display: block !important;
            background: #ededed;
            border-right-color: transparent;
          }
        
          .sumassuredselect select#nonfilterselect {
            position: absolute;
            top: 0;
            width: 100%;
            left: 0;
            right: 0;
            background: #ededed;
            z-index: 1;
            text-align: center;
            border-left-color: transparent;
          }
          .or-jeevan {
            position: relative;
          }
        
          @media (min-width: 1024px) and (max-width: 1366px) {
            .top_space {
              margin-top: 11vh;
            }
          }
          .result-design {
            background-color: #0ab0ef;
            background-color: var(--lumiq-card-bg);
            padding: 20px;
            margin-bottom: 30px;
            float: left;
            width: 100%;
          }
          .total-premium-jeevan-design{
            color: #fff;
            text-align: center;
            padding-bottom: 20px;
            border-bottom: 1px solid #fff;
          }
          .totalpr-jeevan {
            display: inline-block;
            font-size: 25px;
          }
          .price-jeevan {
            display: inline-block;
            font-size: 25px;
            text-decoration: underline;
            margin-left: 20px;
          }
          .total-premium-jeevan-design p {
            margin-top: 7px;
          }
          .total-meturity-jeevan {
            text-align: center;
            color: #fff;
            padding: 35px 0px;
            padding-top: 25px;
          }
          .total-meturity-jeevan h2 {
            background-color: #0ab0ef;
            background-color: var(--lumiq-card-bg);
            padding: 4px;
            z-index: 2;
            position: relative;
            width: 340px;
            margin: auto;
            font-size: 25px;
          }
          .line-jeev {
            width: 430px;
            height: 2px;
            background-color: #fff;
            margin: auto;
            margin-top: -15px;
            z-index: 1;
            position: relative;
          }
          .wd-total-metrurity {
            width: 45.666667%;
          }
          .jeevan-neeves-premium {
            border: 1px solid #fff;
            padding: 17px;
            float: left;
            width: 100%;
            margin-bottom: 30px;
          }
          .listing-total {
            float: left;
            width: 100%;
          }
          .price-jeevan-toal {
            list-style: none;
            color: #fff;
            padding: 0px;
            font-size: 14px;
          }
          .price-jeevan-toal li {
            display: inline-block;
            margin-right: 5px;
          }
          .text-rt-jeevan {
            text-align: right;
            margin-right: 0px !important;
            float: right;
          }
          .total-mrp-jeevan {
            border-top: 1px solid #fff;
            padding-top: 10px;
            font-size: 23px;
            text-align: right;
            color: #fff;
            font-weight: bold;
          }
          .percnt-jeevan {
            float: right;
            background-color: #fff;
            padding: 35px 7px;
            color: #0bb0f0;
            font-size: 23px;
            height: 100px;
            font-weight: bold;
          }
          .or-jeevan {
            position: relative;
          }
          .or-jeevan {
            text-align: center;
            width: 1px;
            height: 150px;
            background-color: #fff;
            margin: auto;
          }
          .or-jeevan p {
            color: #fff;
            font-size: 20px;
            text-transform: uppercase;
            margin: 50px 10px;
            margin-left: -17px;
            background-color: #0bb0f0;
            position: absolute;
          }
         
          @media (max-width: 991px) and (min-width: 768px){
            .guranteedSumAssurdBox{
              padding: 0px 15px 15px 15px;
            }
            .total-premium-jeevan-design {
              padding-bottom: 7px;
            }
            .total-meturity-jeevan {
              margin-bottom: 30px;
            }
            .line-jeev {
              width: 94%;
            }
            .wd-total-metrurity {
              width: 100%;
            }
            .jeevan-neeves-premium {
                margin-bottom: 10px;
                padding: 10px;
            }
            .listing-total {
              width: 100%;
              margin-bottom: 10px;
            }
            .price-jeevan-toal {
              margin-bottom: 5px;
            }
            .price-jeevan-toal li {
              font-size: 12px;
            }
            .total-mrp-jeevan {
              font-size: 20px;
              padding-top: 5px;
            } 
            .percnt-jeevan {
              width: 100%;
              text-align: center;
              height: 40px;
              padding: 0px;
            }
            .or-jeevan {
              width: 100%;
              height: 1px;
              margin: 30px 0px;
            }
            .or-jeevan p {
              width: 45px;
              left: 0px;
              right: 0px;
              margin: auto;
              top: 16px;
            }
          }
          
          @media (max-width: 767px){
            .result-design {
                padding: 12px;
                padding-bottom: 30px;
            }
            .pl-pr {
              padding: 0px;
            }
            .wd-total-metrurity {
              width: 100%;
            }
            .total-premium-jeevan-design {
              padding-bottom: 7px;
            }
            .total-meturity-jeevan {
              margin-bottom: 30px;
            }
            .total-meturity-jeevan h2 {
              font-size: 20px;
              width: 200px;
              display: inline-block;
              margin-top: 15px;
            }
            .line-jeev {
              width: 94%;
            }
            .jeevan-neeves-premium {
              
              padding: 10px;
            }
            .listing-total {
              width: 100%;
              margin-bottom: 10px;
            }
            .price-jeevan-toal {
              margin-bottom: 5px;
            }
            .price-jeevan-toal li {
              font-size: 12px;
            }
            .price-jeevan-toal li {
              font-size: 12px;
            }
            .total-mrp-jeevan {
              font-size: 20px;
              padding-top: 5px;
            }
            .percnt-jeevan {
              width: 100%;
              text-align: center;
              height: 40px;
              padding: 0px;
            }
            .or-jeevan {
              width: 100%;
              height: 1px;
              margin: 30px 0px;
            }
            .or-jeevan p {
              top: -14px;
            }
            .listing-total {
              width: 100%;
              margin-bottom: 10px;
            }
            .price-jeevan-toal {
              margin-bottom: 5px;
            }
          
          }
          
          @media (min-width: 768px) and (max-width: 991px){
            .pl-pr {
              padding: 0px;
            }
            .total-meturity-jeevan h2 {
                font-size: 20px;
                width: 200px;
                display: inline-block;
                margin-top: 15px;
            }
          
          }
          `}
      </style>
      <div className="container">
        <div className="row ps-4 pe-4">
          <div className="col-lg-9 pl-pr brd-right mt-20">
            <div className="row">
              <div className="col-lg-12 pl-pr">
                <div className="iselect-box-design mg-bottom-10 new-iselect-box">
                  <div className="heading-design">
                    <div className="iselect-padding left-side-head">
                      <h1 className="iselect-heading">Your Premium Quotation</h1>
                    </div>
                    <div class="app-quatation mt hidden-desktop-screen">
                      <div class="application-design-number">Application Number: {journeyState.applicationNo}</div>
                    </div>
                  </div>
                  <div class="iselect-padding">
                    <div class="result-design">
                      <div class="row">
                        <div class="col-lg-12 pl-pr">
                          <div class="total-premium-jeevan-design">
                            <div class="totalpr-jeevan">Premium:</div>
                            <div
                              class="price-jeevan"
                              style={{ "textDecoration": "none", "margin-left": "2px" }}
                            >
                              <span class="fa fa-rupee"></span>
                              <strong>{applyComma(Math.floor(data?.[0]?.["MODAL_PREM"])) }</strong>
                              <small style={{ "fontSize": "16px" }}>{getValueFromLookup("premiumFrequency", journeyState.paymentFrequency).toLowerCase()}</small>
                            </div>
                            <p style={{ "fontStyle": "italic" }}>
                            The premium mentioned above is exclusive of all taxes
                            </p>
                          </div>
                          <div class="row">
                            <div class="col-lg-12">
                              <div class="total-meturity-jeevan">
                                <h2>
                                  {" "}
                                  Benefit Details
                                </h2>
                                <div class="line-jeev"></div>
                              </div>
                            </div>
                          </div>
                          {
                            sectionState?.sectionData?.IGFPPlusPlanTypes === "IG2PT1" || sectionState?.sectionData?.IGFPPlusPlanTypes === "IG2PT5" ? 
                            <div class="row guranteedSumAssurdBox" >
                            <div class="col-lg-12 pl pl-pr  " style={{ "paddingRight": "15px" }}>
                              <div class="jeevan-neeves-premium">
                                <div class="listing-total">
                                  <ul class="price-jeevan-toal">
                                    <li>Guaranteed Sum Assured on Maturity</li>
                                    <li class="text-rt-jeevan">
                                      
                                     {`₹${applyComma(Math.floor(data?.[0]?.["GUARANTEED_SAM_DISP"]))}`}
                                    </li>
                                  </ul>
                                  <ul class="price-jeevan-toal">
                                    <li>Total Accrued Guaranteed Additions till Maturity</li>
                                    <li class="text-rt-jeevan">
                                      
                                    {`₹${applyComma(Math.floor(data?.[0]?.["TOTAL_GURAN_ADD_DISP"]))}`}
                                    </li>
                                  </ul>
                                </div>

                              </div>
                            </div>
                          </div>
                            : sectionState?.sectionData?.IGFPPlusPlanTypes === "IG2PT2" || sectionState?.sectionData?.IGFPPlusPlanTypes === "IG2PT6" ? 
                            <div class="row guranteedSumAssurdBox" >
                            <div class="col-lg-12 pl pl-pr  " style={{ "paddingRight": "15px" }}>
                              <div class="jeevan-neeves-premium">
                                <div class="listing-total">
                                  <ul class="price-jeevan-toal">
                                    <li>Guaranteed Income (as per chosen frequency)</li>
                                    <li class="text-rt-jeevan">
                                      
                                     {`₹${applyComma(Math.floor(data?.[0]?.["GI_ANNUAL_DISP"]))}`}
                                    </li>
                                  </ul>
                                  <ul class="price-jeevan-toal">
                                    <li>Total Guaranteed Income</li>
                                    <li class="text-rt-jeevan">
                                      
                                    {`₹${applyComma(Math.floor(data?.[0]?.["GI_TOTAL_DISP"]))}`}
                                    </li>
                                  </ul>
                                  <ul class="price-jeevan-toal">
                                    <li>Total Accrued Guaranteed Additions till Maturity</li>
                                    <li class="text-rt-jeevan">
                                      
                                    {`₹${applyComma(Math.floor(data?.[0]?.["TOTAL_GURAN_ADD_DISP"]))}`}
                                    </li>
                                  </ul>
                                </div>

                              </div>
                            </div>
                          </div> : sectionState?.sectionData?.IGFPPlusPlanTypes === "IG2PT3" ? 
                            <div class="row guranteedSumAssurdBox" >
                            <div class="col-lg-12 pl pl-pr  " style={{ "paddingRight": "15px" }}>
                              <div class="jeevan-neeves-premium">
                                <div class="listing-total">
                                  <ul class="price-jeevan-toal">
                                    <li>Guaranteed Income (as per chosen frequency)</li>
                                    <li class="text-rt-jeevan">
                                      
                                     {`₹${applyComma(Math.floor(data?.[0]?.["GI_ANNUAL_DISP"]))}`}
                                    </li>
                                  </ul>
                                  <ul class="price-jeevan-toal">
                                    <li>Total Guaranteed Income</li>
                                    <li class="text-rt-jeevan">
                                      
                                    {`₹${applyComma(Math.floor(data?.[0]?.["GI_TOTAL_DISP"]))}`}
                                    </li>
                                  </ul>
                                </div>

                              </div>
                            </div>
                          </div> :  sectionState?.sectionData?.IGFPPlusPlanTypes === "IG2PT4" ? 
                            <div class="row guranteedSumAssurdBox" >
                            <div class="col-lg-12 pl pl-pr  " style={{ "paddingRight": "15px" }}>
                              <div class="jeevan-neeves-premium">
                                <div class="listing-total">
                                  <ul class="price-jeevan-toal">
                                    <li>Guaranteed Income (as per chosen frequency)</li>
                                    <li class="text-rt-jeevan">
                                      
                                     {`₹${applyComma(Math.floor(data?.[0]?.["GI_ANNUAL_DISP"]))}`}
                                    </li>
                                  </ul>
                                  <ul class="price-jeevan-toal">
                                    <li>Total Guaranteed Income</li>
                                    <li class="text-rt-jeevan">
                                      
                                    {`₹${applyComma(Math.floor(data?.[0]?.["GI_TOTAL_DISP"]))}`}
                                    </li>
                                  </ul>
                                  <ul class="price-jeevan-toal">
                                    <li>Guaranteed Sum Assured on Maturity (Maturity Benefit)</li>
                                    <li class="text-rt-jeevan">
                                      
                                    {`₹${applyComma(Math.floor(data?.[0]?.["GSAM_DISP"]))}`}
                                    </li>
                                  </ul>
                                </div>

                              </div>
                            </div>
                          </div> : ""
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <div class="hidden-desktop-screen">
                    <div class="iselect-mg-bottom mt-30">
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="but-center text-center">
                            <div class="submit-btn cen" aria-hidden="true" onClick={handlePrevious}> <a >Previous</a> </div>
                            <input  aria-hidden="true" onClick={handleProceed} class="previous-btn cen inline-btn-wd" style={{ "color": "white", "border": "none", "padding": "14px 40px" }} type="button" value="View BI to Proceed" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <p style={{ marginTop: '20px' }}>
              Please note submission of KYC documents including valid proof of age, identity, address, and income is mandatory.
              <a
                href={DocListPDF}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#007bff', textDecoration: 'underline', marginLeft: '5px' }}
              >
                Click here
              </a>{' '}
               to view the list of documents. Further, depending on the medical history of the Life Assured and the underwriting assessment, a medical examination may be required.
            </p>

          </div>
          <RightSideBar 
          sections={props.sections} 
          currentSectionIndex={props.currentSectionIndex} 
          setCurrentSectionIndex={props.setCurrentSectionIndex}     
          showMainButtonFlexiEdgePlan={props.showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={props.setShowMainButtonFlexiEdgePlan}  
          channelForColorChange = {journeyState.channel}      
          />
        </div>
      </div>
      
       {/* Mobile view Buttons */}
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure">
        <div className="iselect-mg-bottom">
            <div className="row">
                <div className="col-lg-12">
                    <div className="but-center text-center">
                        <div className="submit-btn cen" style={{paddingLeft:"5px"}} aria-hidden="true" onClick={handlePrevious}> <a >Previous </a> </div>
                        <input aria-hidden="true" onClick={handleProceed} className="previous-btn cen bi-btv" style={{color: "white", padding: "14px 0px", border:"none", marginLeft:"10px", width:"160px"}} type="button" form="aDetail" align="right" value="View BI to Proceed" />
                    </div>
                </div>
            </div>
        </div>
      </div>
    </>
  )
}